import React from 'react';
import { motion } from 'framer-motion';
const costs = [{
  sin: 'Recetas de YouTube que no salen igual',
  real: 'Ingredientes tirados + tiempo perdido + frustración'
}, {
  sin: 'Precios calculados a ojo',
  real: 'Trabajás 40 horas y ganás lo mismo que si hubieras descansado'
}, {
  sin: 'Sin planilla de costos',
  real: '$180 de pérdida por alfajor sin saberlo'
}, {
  sin: 'Sin sistema de WhatsApp',
  real: '2 horas diarias respondiendo lo mismo sin convertir'
}, {
  sin: 'Sin packaging profesional',
  real: 'El mismo producto vale 40% menos a la vista'
}, {
  sin: 'Sin estrategia de menú',
  real: 'Siempre lo mismo, siempre el mismo precio, siempre el mismo ingreso'
}, {
  sin: 'Finde que viene: mismo ciclo',
  real: 'El año que viene en el mismo lugar'
}];
export function CostComparisonTable() {
  return <section className="py-12 px-4 bg-cream-dark/20" data-id="element-43">
      <div className="max-w-4xl mx-auto" data-id="element-44">
        <div className="text-center mb-12" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-serif" data-id="element-46">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-warm border border-cream-dark overflow-hidden mb-12" data-id="element-47">
          <div className="grid grid-cols-2 bg-carbon text-white font-bold" data-id="element-48">
            <div className="p-4 text-center border-r border-carbon-lighter bg-red-900/20" data-id="element-49">
              Sin Megapack
            </div>
            <div className="p-4 text-center" data-id="element-50">Costo Real</div>
          </div>

          <div className="divide-y divide-cream-dark" data-id="element-51">
            {costs.map((item, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="grid grid-cols-2 hover:bg-cream-light transition-colors" data-id="element-52">
                <div className="p-4 text-sm text-carbon-lighter border-r border-cream-dark flex items-center" data-id="element-53">
                  <span className="text-red-500 mr-2 flex-shrink-0" data-id="element-54">❌</span>{' '}
                  {item.sin}
                </div>
                <div className="p-4 text-sm font-medium text-carbon flex items-center" data-id="element-55">
                  {item.real}
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-56">
          <p className="text-2xl md:text-3xl font-bold text-brand-green mb-4" data-id="element-57">
            El próximo finde puede ser diferente.
          </p>
          <p className="text-xl font-serif italic text-carbon-lighter font-[600]" data-id="element-58">
            "La cocina que ya sabés hacer puede convertirse en el negocio que
            siempre quisiste tener." 🍪
          </p>
        </div>
      </div>
    </section>;
}